export {
  APPOINTMENT_STATUSES,
} from "@jourfx/types/appointments";
export type {
  AppointmentStatus,
} from "@jourfx/types/appointments";

import type { AppointmentStatus } from "@jourfx/types/appointments";

export const STATUS_VARIANT: Record<
  AppointmentStatus,
  "default" | "secondary" | "outline" | "destructive"
> = {
  scheduled: "outline",
  confirmed: "default",
  in_progress: "secondary",
  completed: "secondary",
  cancelled: "destructive",
  no_show: "destructive",
};

export function formatLocalDateTimeInput(timestamp?: number | null) {
  if (!timestamp) return "";

  const date = new Date(timestamp);
  const offset = date.getTimezoneOffset();
  const local = new Date(date.getTime() - offset * 60 * 1000);
  return local.toISOString().slice(0, 16);
}

export function parseLocalDateTimeInput(value: string) {
  if (!value) return undefined;

  const parsed = new Date(value);
  const timestamp = parsed.getTime();
  return Number.isNaN(timestamp) ? undefined : timestamp;
}
